import React from 'react';

import { getArticleGroup } from 'SharedPartials/getArticleGroup';

export const getSplitIndexContent = ({
  content,
  title,
  extraClassNames,
  articlesPerRow,
  articleCardProps,
  isMobile,
}) => {
  let groupElems = []; // Build up collection of elements to add to the articlegroup
  const articleGroups = []; // Build up a collection of articleGroups

  content.forEach(item => {
    if (item.name) {
      // If there is a name this is an ad
      if (item.name === 'Desktop Ad') {
        if (!isMobile) {
          articleGroups.push(
            getArticleGroup({
              title,
              content: groupElems,
              extraClassNames,
              articlesPerRow,
              articleCardProps,
            }),
          );
          articleGroups.push(item.component);
          groupElems = [];
        }
      }

      if (item.name === 'Mobile Ad') {
        if (isMobile) {
          articleGroups.push(
            <div>
              {getArticleGroup({
                title,
                content: groupElems,
                extraClassNames,
                articlesPerRow,
                articleCardProps,
              })}
            </div>,
          );
          articleGroups.push(item.component);
          groupElems = [];
        }
      }
    } else {
      groupElems.push(item);
    }
  });

  if (groupElems.length > 0) {
    articleGroups.push(
      getArticleGroup({
        title,
        content: groupElems,
        extraClassNames,
        articlesPerRow,
        articleCardProps,
      }),
    );
  }

  return articleGroups;
};
